import {pujaReducer} from "./pujaReducer";
import { donationReducer } from "./donationReducer";
import notificationReducer from "./notificationReducer";
import { bookReducer } from "./bookReducer";
import { combineReducers } from "redux";


export default combineReducers({
  puja: pujaReducer,
  donation: donationReducer,
  book:bookReducer,
  notification: notificationReducer
});
